import {HttpClient, HttpStatusCode} from 'data/protocols/http';
import {APIError} from 'data/errors/api-error';
import {
	GetAuthorizationsOdonto,
	GetAuthorizationsOdontoModel,
	AuthorizationsOdontoParams,
} from 'domain/usecases/private/authorizations-odonto/get-authorizations-odonto';

export class RemoteGetAuthorizationsOdonto implements GetAuthorizationsOdonto {
	constructor(
		private readonly url: string,
		private readonly httpClient: HttpClient<GetAuthorizationsOdontoModel>,
	) {}

	async get({
		signal,
		...params
	}: AuthorizationsOdontoParams): Promise<GetAuthorizationsOdontoModel> {
		const httpResponse = await this.httpClient.request({
			url: this.url,
			method: 'get',
			params,
			signal,
		});

		switch (httpResponse.status) {
			case HttpStatusCode.ok:
				return httpResponse.data;
			case HttpStatusCode.created:
				return httpResponse.data;
			case HttpStatusCode.noContent:
				return httpResponse.data;
			default:
				throw new APIError(httpResponse.status, httpResponse.data);
		}
	}
}
